export function getPropertyUrl(
  propertyEndpoint?: string,
  editionEndpoint?: string,
  trailingSlash: boolean = false
): string {
  let home;

  if (propertyEndpoint) {
    home = propertyEndpoint.includes('https://')
      ? propertyEndpoint
      : `https://${propertyEndpoint}`;
  } else {
    home = editionEndpoint?.includes('https://')
      ? editionEndpoint
      : `https://${editionEndpoint}`;
  }

  if (trailingSlash && !home.endsWith('/')) {
    home += '/';
  } else if (!trailingSlash && home.endsWith('/')) {
    home = home.slice(0, -1);
  }

  return home;
}
